import dotProp from 'dot-prop-immutable'
import { LOAD_SCHEDULE_SUCCESS } from '../actions/types'
import { token } from '../utils'
const initialState = {
  events: []
}
const schedule = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SCHEDULE_SUCCESS: {
      return {
        ...state,
        events: action.payload,
      }
    }
    default:
      return state
  }
}

export default schedule



// WEBPACK FOOTER //
// ./src/reducers/schedule.js